module.exports = __webpack_public_path__ + "static/day05-2b4efa574cbc0e7fe416c90ceaa13fca.png";